<template>
  <div class="content">
    <div class="category-list" v-if="category.length > 0">
      <div v-for="firstItem in category" :key="firstItem.categoryId" v-if="firstItem.urlName === first">
        <div v-for="secondItem in firstItem.children" :key="secondItem.categoryId"
             v-if="secondItem.urlName === second">
          <a href="javascript:void(0)" :disabled="!third" :id="!third?'active':''" @click="change()">全部</a>
          <a href="javascript:void(0)" :disabled="third===item.urlName" :id="third===item.urlName?'active':''"
             @click="change(item.urlName)"
             v-for="item in secondItem.children">{{ item.categoryName }}</a>
        </div>
      </div>
    </div>
    <div v-if="category.length===0" style="padding: 10px">
      加载中...
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  computed: {
    ...mapState(["category"]),
  },
  props: {
    first: {
      type: String,
    },
    second: {
      type: String,
    },
    third: {
      type: String,
    },
  },
  methods: {
    change(urlName) {
      if (this.third === urlName){
        return;
      }
      if (urlName){
        this.$router.push("/"+this.first+"/"+this.second+"?category="+urlName)
      }else {
        this.$router.push("/"+this.first+"/"+this.second)
      }
    }
  }
}
</script>

<style lang="scss">
#active {
  color: $base-color-primary;
}

.category-list {
  a {
    font-size: 14px;
    color: --color(--p-text-34);
    display: inline-block;
    margin-right: 14px;
    margin-bottom: 6px;
  }
}
</style>
